import { useEffect, useState } from 'react';
import { useRolesAccessContext } from '../context/RolesAccessContext';
import { Access } from '../Interfaces/admin/Role.interfaces';
import {
  PROCESS_OPTIONS,
  ProcessOption,
  ProcessVisibilityRule,
} from '../../utils/rolesConst';

const getVisibleOptions = (
  rolesAcess: Access[] | undefined,
  isAdmin: boolean | undefined,
  options: ProcessOption[] = PROCESS_OPTIONS
): ProcessOption[] =>
  options.filter((opt) => {
    if (opt.visibilityRule === ProcessVisibilityRule.ADMIN)
      return isAdmin ?? false;
    return rolesAcess?.some((a) => a.report === opt.value) ?? false;
  });

const useVisibleProcessOptions = (
  options: ProcessOption[] = PROCESS_OPTIONS
) => {
  const { rolesAcess, isAdmin } = useRolesAccessContext();
  const [visibleOptions, setVisibleOptions] = useState<ProcessOption[]>(
    getVisibleOptions(rolesAcess, isAdmin, options)
  );

  useEffect(() => {
    setVisibleOptions(getVisibleOptions(rolesAcess, isAdmin, options));
  }, [rolesAcess, isAdmin, options]);

  return visibleOptions;
};

export default useVisibleProcessOptions;
